import {EntityType} from "../../../gd/const/item"
import {ViewType} from "../../../gd/const/views/view-type"
import {getViewSystemType} from "../../../gd/const/views/get-view-system-type";
import View from "../../view/view";
import {ViewPersonalConfig} from "../@type";
import {PersonalViewLocation} from "./@types";
import NavigationSection from "../../navigation/navigation-section";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import {PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const";
import {BUS_ON_PERSONAL_EVENT_LOCATION_CHANGE} from "./@const";
import Navigation_ButtonNotifications from "../../../../layout/navigation/buttons/notifications";
import Navigation_ButtonAttendance from "../../../../layout/navigation/buttons/my-attendance";
import {BUS_NAVIGATION_CHANGED} from "../../../../layout/navigation/@const";
import MyWorkLocalSettings from "../../../../app/home/my-work-local-settings";
import {myWorkViewDictionary} from "../../../../app/home/my-work/common/@const";
import MyTasksLocalSettings from "../../../../views/my-tasks/manager/local-settings";
import {myTasksViewPathDictionary} from "../../../../views/my-tasks/@const";
import {featureAccess} from "../../../gd/access-control/feature-access/feature-access";

const debug = false
// const debug = "PersonalView"


export default class PersonalView extends View {

    // private _location           : NavigationSectionType
    private _config                 : ViewPersonalConfig

    constructor(config:ViewPersonalConfig) {

        debug && console.log(debug, "constructor() config=", config)

        // patch - id is required!
        // @ts-ignore
        config.id = !!config.id ? config.id : config.type

        super(config, config.type , EntityType.CUSTOM_VIEW)

        this._config = config


        // this._location = _.get(data,'params.location', getCustomViewDefaultLocation(this.type))
        // this._location = Navigation
        //
        //


        // // params
        // this.params = !_.isNil(data.params) ? data.params : {}; // _.get(data,'params', {}) for params null default object is not set

        //
        // this.icon           = _.get(this._config, 'icon', 'i5-icon-task')
        //
        // // Patch for unsupported views
        // if (!this._config) {
        //     console.error("View ", this.type, "not found in const error #CUSTOMVIEW-23")
        //     return
        // }

    }

    get systemType():ViewType {
        return getViewSystemType(this.type)
    }

    get viewId() {return "view-"+this.id}

    get entityType() { return EntityType.CUSTOM_VIEW }




    get viewType():ViewType {
        return this.type
    }

    get url():string {

        switch (this.type) {
            case ViewType.MY_WORK:
                const myWorkLocalSettings = new MyWorkLocalSettings()

                const viewName = myWorkViewDictionary[myWorkLocalSettings.currentViewType]

                let myWorkDefaultUrl: string = ""

                if (myWorkLocalSettings.currentViewId === viewName) {
                    myWorkDefaultUrl = "my-work/{0}".f(viewName)
                } else {
                    myWorkDefaultUrl = "my-work/{0}/{1}".f(viewName, myWorkLocalSettings.currentViewId)
                }

                return myWorkDefaultUrl

            case ViewType.MY_TASKS_LIST:
                const myTasksLocalSettings = new MyTasksLocalSettings()

                const viewPath = myTasksViewPathDictionary[myTasksLocalSettings.currentView]

                let myTasksDefaultUrl: string = ""

                if (myTasksLocalSettings.currentViewId === myTasksLocalSettings.currentView) {
                    myTasksDefaultUrl = "my-tasks/{0}".f(viewPath)
                } else {
                    myTasksDefaultUrl = "my-tasks/{0}/{1}".f(viewPath, myTasksLocalSettings.currentViewId)
                }

                return myTasksDefaultUrl
            default:
                return this._config.url!
        }

    }

    open = () => {

        if (!!this._config.feature && !featureAccess(this._config.feature)) {
            gd.modals.other.upgrade(this._config.feature)
            return
        }

        debug && console.log(debug, "open() url=", this.url)
        gd.goTo(this.url);
    }


    // check if this view is open right now
    get isOpen():boolean {
        const fragment : string = gd.router.history.fragment || '';

        return _.startsWith(fragment, this.url)
    }

    get locationOptions():Option[] {
        // return getViewLocationOptions(this.type)


        // console.green(type)
        // stupid konechno nado facotry bilo delat'
        switch (this.type) {

            case ViewType.MY_WORK:
            case ViewType.NOTIFICATIONS:
                return [
                    {
                        label: "Main Menu", value: PersonalViewLocation.HOME, icon: 'i5-nav-home'
                    },
                    {
                        label       : "More Menu",
                        value       : PersonalViewLocation.HOME_MORE,
                        icon        : 'i5-long-arrow-down',
                        disabled    : true
                    },
                    {
                        type        : PopoverMenuItemType.SEPARATOR
                    },
                    {
                        label: "Navigation Panel", value: PersonalViewLocation.NAVIGATION_PANEL, icon :'i5-panel'
                    },

                ]


            default:
                return [
                    {
                        label: "Main Menu", value: PersonalViewLocation.HOME, icon: 'i5-nav-home'
                    },
                    {
                        label: "More Menu",
                        value: PersonalViewLocation.HOME_MORE,
                        // icon: 'i5-more'
                        icon: 'i5-long-arrow-down'
                    },
                    {
                        type        : PopoverMenuItemType.SEPARATOR
                    },
                    {
                        label: "Navigation Panel", value: PersonalViewLocation.NAVIGATION_PANEL, icon :'i5-panel'
                    },


                ]
        }


    }

    // Getters & Setters

    get inNavigationPanel():boolean {
        return this.location === PersonalViewLocation.NAVIGATION_PANEL
    }

    get location():PersonalViewLocation {
        // if attendance is required then it should be in navigation panel
        if (this.viewType === ViewType.MY_ATTENDANCE) {
            const isRequired = gd.session.companyUsers.getByUserId(gd.user.id)?.clockInOutEnabled
            if (isRequired) {
                return PersonalViewLocation.NAVIGATION_PANEL
            }
        }

        return _.get(gd.user.settings.navigation.personalViews, this.viewType, this._config.defaultLocation)
        // return PersonalViewLocation.HOME
    }

    set location(viewLocation: PersonalViewLocation) {

        debug && console.log(debug, "View", this.name, "set location ", viewLocation)

        if (viewLocation === PersonalViewLocation.NAVIGATION_PANEL) {
            // Super important - because this view changes location make sure it no set as default view for any of the sections
            gd.navigationStructure.removeUrlFromDefaultSectionsPage(this.url)
        }

        gd.user.settings.navigation.personalViews[this.type] = viewLocation
        gd.user.settings.save()


        // on nav update block

        gd.layout.navigation.reset()
        gd.layout.navigation.reRender("CustomView on location set")
        gd.layout.currentMenu?.reRender()

        // apply app specific navigation behaviour
        const app: any = gd.getMainApp()
        if (app?.updateMainNavigation) app.updateMainNavigation()

        gd.bus.triggerEvent(BUS_NAVIGATION_CHANGED)

        // end

    }

    get navigationSection(): NavigationSection {
        switch (this.location) {

            case PersonalViewLocation.HOME:
            case PersonalViewLocation.HOME_MORE:
                return gd.navigationStructure.get(NavigationSectionType.HOME)

            case PersonalViewLocation.NAVIGATION_PANEL:
                return gd.navigationStructure.get("personal-view-"+this.id)


            default:
                console.red("location "+ this.location+" is unknown...")
                return gd.navigationStructure.defaultSection
        }
    }

    get canChangeLocation(): boolean {
        return true
    }

    toNavigationSection() : NavigationSection {

        switch (this.type) {

            case ViewType.MY_WORK:

                const myWorkLocalSettings = new MyWorkLocalSettings()

                let myWorkViewName = myWorkViewDictionary[myWorkLocalSettings.currentViewType]

                let myWorkDefaultUrl: string = ""

                if (myWorkLocalSettings.currentViewId === myWorkViewName) {
                    myWorkDefaultUrl = "my-work/{0}".f(myWorkViewName)
                } else {
                    myWorkDefaultUrl = "my-work/{0}/{1}".f(myWorkViewName, myWorkLocalSettings.currentViewId)
                }

                return new NavigationSection({
                    id              : 'my-work',
                    icon            : "i5-my-work-new",
                    hint            : "My Work",
                    renderComponent : Navigation_ButtonGenericDeprecated,
                    onClick         : gd.navigationStructure.onClickApp,
                    url             : myWorkDefaultUrl,
                    type            : NavigationSectionType.PERSONAL_VIEW,
                    position        : NavigationButtonPosition.TOP,
                    personalView    : this
                })

            case ViewType.NOTIFICATIONS:
                return new NavigationSection({
                    id              : 'notifications',
                    icon            : "i5-notification",
                    hint            : "Notifications",
                    renderComponent : Navigation_ButtonNotifications,
                    onClick         : gd.navigationStructure.onClickApp,
                    type            : NavigationSectionType.PERSONAL_VIEW,
                    url             : 'notifications',
                    position        : NavigationButtonPosition.TOP,
                    personalView    : this
                })

            case ViewType.MY_ATTENDANCE:

                return new NavigationSection({
                    id              : 'personal-view-' + this.id,
                    name            : this.name,
                    icon            : this.icon, //  "i5-my-kiosk",
                    iconActive      : this.icon,
                    hint            : this.name,

                    renderComponent : Navigation_ButtonAttendance,
                    type            : NavigationSectionType.PERSONAL_VIEW,
                    menuComponent   : this._config.mainMenuComponent,
                    onClick         : this.open,
                    personalView    : this
                })

            case ViewType.MY_TASKS_LIST:

                const myTasksLocalSettings = new MyTasksLocalSettings()

                const viewPath = myTasksViewPathDictionary[myTasksLocalSettings.currentView]

                let myTasksDefaultUrl: string = ""

                if (myTasksLocalSettings.currentViewId === myTasksLocalSettings.currentView) {
                    myTasksDefaultUrl = "my-tasks/{0}".f(viewPath)
                } else {
                    myTasksDefaultUrl = "my-tasks/{0}/{1}".f(viewPath, myTasksLocalSettings.currentViewId)
                }

                return new NavigationSection({
                    id              : 'personal-view-' + this.id,
                    name            : this.name,
                    icon            : this.icon,
                    iconActive      : this.icon,
                    hint            : this.name,
                    renderComponent : Navigation_ButtonGenericDeprecated,
                    type            : NavigationSectionType.PERSONAL_VIEW,
                    menuComponent   : this._config.mainMenuComponent,
                    url             : myTasksDefaultUrl,
                    onClick         : gd.navigationStructure.onClickApp,
                    personalView    : this
                })
            case ViewType.MY_GOALS:

                return new NavigationSection({
                    id              : 'personal-view-' + this.id,
                    name            : this.name,
                    icon            : this.icon,
                    iconActive      : this.icon,
                    hint            : this.name,
                    renderComponent : Navigation_ButtonGenericDeprecated,
                    type            : NavigationSectionType.PERSONAL_VIEW,
                    menuComponent   : this._config.mainMenuComponent,
                    onClick         : gd.navigationStructure.onClickDefault,
                    personalView    : this
                })

            default:
                return new NavigationSection({
                    id              : 'personal-view-' + this.id,
                    name            : this.name,
                    icon            : this.icon,
                    iconActive      : this.icon,
                    hint            : this.name,
                    renderComponent : Navigation_ButtonGenericDeprecated,
                    type            : NavigationSectionType.PERSONAL_VIEW,
                    menuComponent   : this._config.mainMenuComponent,
                    url             : this.url,
                    onClick         : gd.navigationStructure.onClickApp,
                    personalView    : this
                })
        }

    }


    toJSON():JSONObject {

        const settings: any = this.settings

        return {
            id                  : this.id,
            companyId           : gd.companyId,
            type                : this.type,
            name                : this.name,
            // _location           : this._location,
        }
    }

    menuMoreOptions = () : Option[] => {

        // if attendace required user should not be able to turn it off !!!
        if (this.viewType === ViewType.MY_ATTENDANCE) {
            const isRequired = gd.session.companyUsers.getByUserId(gd.user.id)?.clockInOutEnabled
            if (isRequired) {
                return []
            }
        }



        const moreOptions : Option[] = [
            {
                type    : PopoverMenuItemType.HEADER,
                label   : 'Display In:'
            },
        ]

        // add display options
        _.map(this.locationOptions, (option:Option) => {
            option              = _.clone(option)    // because we modify it below
            option.isSelected   = option.value === this.location
            option.onClick      = () => {
                this.location   = option.value as PersonalViewLocation
                gd.bus.triggerEvent(BUS_ON_PERSONAL_EVENT_LOCATION_CHANGE)

                // interesting ... maybe when we pin it we always should go there ?
                if (option.value === PersonalViewLocation.HOME || option.value === PersonalViewLocation.NAVIGATION_PANEL) {
                    this.open()
                }

            }
            moreOptions.push(option)
        })

        return moreOptions


    }


}


